import React, { Fragment, useContext, useEffect, useState } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import { connect } from 'react-redux';
import Editor from '@jsx/components/RichTextEditor';
import { AdminActions } from '@adapters/redux/reducer/admin';
import PageLoader from '../Loader/PageLoader';
import { fullBackendPath } from 'core/helpers';
import { ToastNotificationContext } from '@context/ToastNotificationContext';

const Page = (props) => {
  const { notifySuccess, notifyError } = useContext(ToastNotificationContext);
  const {
    aboutUs,
    updateData,
    updating,
    section1,
    section2,
    section3,
    subscribe_section,
    experience_intro,
  } = props;
  const {
    id: section1Id,
    describe: describe1,
    describe_vi: describe1Vie,
    sec1_image1,
    sec1_image2,
  } = section1;
  const {
    id: section2Id,
    describe: describe2,
    describe_vi: describe2Vie,
    sec2_image,
    percent1: p1,
    percent2: p2,
    percent3: p3,
    progress_bar1: pb1,
    progress_bar1_vi: pb1Vie,
    progress_bar2: pb2,
    progress_bar2_vi: pb2Vie,
    progress_bar3: pb3,
    progress_bar3_vi: pb3Vie,
  } = section2;
  const {
    id: section3Id,
    describe: describe3,
    describe_vi: describe3Vie,
    link: s3Link,
    sec3_image,
  } = section3;
  const {
    id: section4Id,
    describe: describe4,
    describe_vi: describe4Vie,
    sec3_image: experienceIntroImage,
  } = experience_intro;

  const [hidden1, setHidden1] = useState(true);
  const [hidden2, setHidden2] = useState(true);
  const [hidden3, setHidden3] = useState(true);

  // Section 1
  const [section1Describe, setSection1Describe] = useState(describe1);
  const [section1DescribeVie, setSection1DescribeVie] = useState(describe1Vie);
  const [section1Image1, setSection1Image1] = useState(null);
  const [section1Image2, setSection1Image2] = useState(null);

  // Section 2
  const [section2Describe, setSection2Describe] = useState(describe2);
  const [section2DescribeVie, setSection2DescribeVie] = useState(describe2Vie);
  const [section2Image, setSection2Image] = useState(null);

  // Section 3
  const [section3Describe, setSection3Describe] = useState(describe3);
  const [section3DescribeVie, setSection3DescribeVie] = useState(describe3Vie);
  const [section3Image, setSection3Image] = useState(null);
  const [link, setLink] = useState(s3Link);

  const [section4Describe, setSection4Describe] = useState(describe4);
  const [section4DescribeVie, setSection4DescribeVie] = useState(describe4Vie);
  const [section4Image, setSection4Image] = useState(null);

  const onSubmitUpdateSection1 = () => {
    const params = {
      describe: section1Describe,
      describe_vi: section1DescribeVie,
      images: [],
    };

    if (section1Image1)
      params.images.push({
        field: 'sec1_image1',
        image: section1Image1,
      });

    if (section1Image2)
      params.images.push({
        field: 'sec1_image2',
        image: section1Image2,
      });

    updateData('put', 'section1/1', params, 'section1', (isError, error) => {
      if (isError) {
        notifyError(error);
      } else {
        notifySuccess('Update aNhill Introduction successfully');
        setSection1Image1(null);
        setSection1Image2(null);
      }
    });
  };

  const onSubmitUpdateSection2 = () => {
    const params = {
      describe: section2Describe,
      describe_vi: section2DescribeVie,
      images: [],
    };

    if (section2Image)
      params.images.push({
        field: 'sec2_image',
        image: section2Image,
      });

    updateData('put', 'section2/1', params, 'section2', (isError, error) => {
      if (isError) {
        notifyError(error);
      } else {
        notifySuccess('Update Dining Introduction successfully');
        setSection2Image(null);
      }
    });
  };

  const onSubmitUpdateSection3 = () => {
    const params = {
      describe: section3Describe,
      describe_vi: section3DescribeVie,
      link,
      images: [],
    };

    if (section3Image)
      params.images.push({
        field: 'sec3_image',
        image: section3Image,
      });

    updateData('put', 'section3/1', params, 'section3', (isError, error) => {
      if (isError) {
        notifyError(error);
      } else {
        notifySuccess('Update Spa & Wellness Introduction successfully');
        setSection3Image(null);
      }
    });
  };

  const onSubmitUpdateSection4 = () => {
    const params = {
      describe: section4Describe,
      describe_vi: section4DescribeVie,
      images: [],
    };

    if (section4Image)
      params.images.push({
        field: 'sec3_image',
        image: section4Image,
      });

    updateData(
      'put',
      'experience-intro',
      params,
      'experience_intro',
      (isError, error) => {
        if (isError) {
          notifyError(error);
        } else {
          notifySuccess('Update Experience Introduction successfully');
          setSection4Image(null);
        }
      }
    );
  };

  return (
    <Fragment>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmitUpdateSection1();
        }}
      >
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">aNhill Introduction</h4>
              </div>
              <div className="card-body position-relative custom-ekeditor">
                {updating && <PageLoader />}
                <div className="row">
                  <div className="editor-container mb-4">
                    <label className="form-label">Describe (ENG)</label>
                    <Editor
                      value={section1Describe}
                      onChange={setSection1Describe}
                    />
                  </div>
                  <div className="editor-container mb-3">
                    <label className="form-label">Describe (VIE)</label>
                    <Editor
                      value={section1DescribeVie}
                      onChange={setSection1DescribeVie}
                    />
                  </div>
                  <div className="form-group">
                    <div className="mb-3 col-md-12">
                      <label className="form-label">Change Image 1</label>
                      <input
                        className="form-control"
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={(e) => setSection1Image1(e.target.files[0])}
                      />
                    </div>
                    {sec1_image1?.path && (
                      <div className="form-group mb-3">
                        <label className="form-label col-12">
                          Current Image 1
                        </label>
                        <div className="col-md-6 offset-md-3">
                          <img
                            className="img-responsive"
                            width={'100%'}
                            src={fullBackendPath(sec1_image1?.path)}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  {/* <div className="form-group mb-3 col-md-6">
                    <div className="mb-3 col-md-12">
                      <label className="form-label">Change Image 2</label>
                      <input
                        className="form-control"
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={(e) => setSection1Image2(e.target.files[0])}
                      />
                    </div>
                    {sec1_image2?.path && (
                      <div className="form-group mb-3 col-md-12">
                        <label className="form-label col-12">
                          Current Image 2
                        </label>
                        <img
                          className="img-responsive"
                          width={'100%'}
                          src={fullBackendPath(sec1_image2?.path)}
                        />
                      </div>
                    )}
                  </div> */}
                </div>
                <div className="text-center mt-3">
                  <button type="submit" className="btn btn-primary">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmitUpdateSection2();
        }}
      >
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Dining Introduction</h4>
              </div>
              <div className="card-body custom-ekeditor">
                {updating && <PageLoader />}
                <div className="editor-container mb-4">
                  <label className="form-label">Describe (ENG)</label>
                  <Editor
                    value={section2Describe}
                    onChange={setSection2Describe}
                  />
                </div>
                <div className="editor-container">
                  <label className="form-label">Describe (VIE)</label>
                  <Editor
                    value={section2DescribeVie}
                    onChange={setSection2DescribeVie}
                  />
                </div>
                <div className="file-container mt-3">
                  <div className="mb-3">
                    <label className="form-label">Change Image</label>
                    <input
                      className="form-control"
                      type="file"
                      accept="image/png, image/jpeg"
                      onChange={(e) => setSection2Image(e.target.files[0])}
                    />
                  </div>
                  {sec2_image?.path && (
                    <div className="form-group mb-3 col-md-12">
                      <label className="form-label col-12">Current Image</label>
                      <div className="col-md-6 offset-md-3">
                        <img
                          className="img-responsive"
                          width={'100%'}
                          src={fullBackendPath(sec2_image?.path)}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="text-center mt-3">
                  <button type="submit" className="btn btn-primary">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmitUpdateSection3();
        }}
      >
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Spa & Wellness Introduction</h4>
              </div>
              <div className="card-body position-relative custom-ekeditor">
                {updating && <PageLoader />}
                <div className="editor-container mb-4">
                  <label className="form-label">Describe (ENG)</label>
                  <Editor
                    value={section3Describe}
                    onChange={setSection3Describe}
                  />
                </div>
                <div className="editor-container">
                  <label className="form-label">Describe (VIE)</label>
                  <Editor
                    value={section3DescribeVie}
                    onChange={setSection3DescribeVie}
                  />
                </div>
                <div className="file-container mt-3">
                  <div className="mb-3">
                    <label className="form-label">Change Image</label>
                    <input
                      className="form-control"
                      type="file"
                      accept="image/png, image/jpeg"
                      onChange={(e) => setSection3Image(e.target.files[0])}
                    />
                  </div>
                  {sec3_image?.path && (
                    <div className="form-group mb-3 col-md-12">
                      <label className="form-label col-12">Current Image</label>
                      <div className="col-md-6 offset-md-3">
                        <img
                          className="img-responsive"
                          width={'100%'}
                          src={fullBackendPath(sec3_image?.path)}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="text-center mb-3">
                  <button type="submit" className="btn btn-primary">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmitUpdateSection4();
        }}
      >
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Experience Introduction</h4>
              </div>
              <div className="card-body position-relative custom-ekeditor">
                {updating && <PageLoader />}
                <div className="editor-container mb-4">
                  <label className="form-label">Describe (ENG)</label>
                  <Editor
                    value={section4Describe}
                    onChange={setSection4Describe}
                  />
                </div>
                <div className="editor-container">
                  <label className="form-label">Describe (VIE)</label>
                  <Editor
                    value={section4DescribeVie}
                    onChange={setSection4DescribeVie}
                  />
                </div>
                <div className="file-container mt-3">
                  <div className="mb-3">
                    <label className="form-label">Change Image</label>
                    <input
                      className="form-control"
                      type="file"
                      accept="image/png, image/jpeg"
                      onChange={(e) => setSection4Image(e.target.files[0])}
                    />
                  </div>
                  {experienceIntroImage?.path && (
                    <div className="form-group mb-3 col-md-12">
                      <label className="form-label col-12">Current Image</label>
                      <div className="col-md-6 offset-md-3">
                        <img
                          className="img-responsive"
                          width={'100%'}
                          src={fullBackendPath(experienceIntroImage?.path)}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="text-center mb-3">
                  <button type="submit" className="btn btn-primary">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  section1: state.admin.section1,
  section2: state.admin.section2,
  section3: state.admin.section3,
  experience_intro: state.admin.experience_intro,
  subscribe_section: state.admin.subscribe_section,
  updating: state.admin.updating,
});

const mapDispatchToProps = (dispatch) => ({
  updateData: (method, url, params, field, callback) =>
    dispatch(AdminActions.updateData(method, url, params, field, callback)),
});

const withErrorBoundary = (props) => (
  <ErrorBoundary>
    <Page {...props} />
  </ErrorBoundary>
);

export default connect(mapStateToProps, mapDispatchToProps)(withErrorBoundary);
